import { PaginationTypes } from 'types/common.types'
import {
    MoveInDatePatchType,
    OnboardIssueDataType,
    UpdateOnboardingData,
    ApproveRejectTypes,
    GetDocumentTypes,
    ChangeMobileNumberType,
    CollectionLedgerTypes,
    PendingPaymentDataType,
    InspectionQueryParams,
    CreateInspectionPayload,
    UpdateInspectionPayload
} from 'types/onboarding.types'
import { SortingKeys } from 'types/property-management.types'
import { apiRequest } from 'utils/axios'
import { EVICTION_APIS, ONBOARDING_APIS } from 'utils/eps'
import { KYCDocumentType } from 'types/onboarding.types'
import { KYC_APIS } from 'utils/eps'

export const GET_LIST_ONBOARDING = (
    page: number | undefined,
    limit: number | undefined,
    type: string | undefined,
    search: string | undefined,
    status: string | undefined,
    mid_from: string | undefined,
    mid_to: string | undefined,
    onboardSortingOptions: SortingKeys,
    onboardFilterOptions: Record<string, any>,
    propertyManagerId?: string
): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.LIST_ONBOARDING,
        method: 'get',
        params: {
            page,
            limit,
            ...(type ? { type } : {}),
            ...(search ? { search } : {}),
            ...(status ? { status } : {}),
            ...(mid_from ? { mid_from } : {}),
            ...(mid_to ? { mid_to } : {}),
            ...(onboardSortingOptions?.sort ? { sort: onboardSortingOptions?.sort } : {}),
            ...(onboardFilterOptions?.city ? { city: onboardFilterOptions?.city } : {}),
            ...(propertyManagerId ? { property_manager_id: propertyManagerId } : {})
        }
    })
}

export const GET_ONBOARDING_ID = (id: string): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.SINGLE_ONBOARDING(id), method: 'get' })
}

export const POST_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.CREATE_ONBOARDING, method: 'post', data: values })
}
export const POST_PAYMENT_LINK_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    return apiRequest.withTokenPayment({ url: ONBOARDING_APIS.PAYMENT_LINK_ONBOARDING, method: 'post', data: values })
}
export const PATCH_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.UPDATE_ONBOARDING(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}

export const PATCH_LIMITED_FIELDS_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.UPDATE_LIMITED_FIELDS_ONBOARDING(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}

export const HANDOVER_ONBOARDING_UPDATE = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.ONBOARDING_HANDOVER(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}

export const AGREEMENT_SENT_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.AGREEMENT_SENT(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}
export const CANCEL_ONBOARDING = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.CANCEL_ONBOARDING(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}
export const POST_COLLECTION_DETAILS = (values: UpdateOnboardingData): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.CREATE_COLLECTION_DETAILS(onboardingId ?? ''),
        method: 'post',
        data: values
    })
}

export const PATCH_ONBOARDING_APRROVE_REJECT = (values: ApproveRejectTypes): Promise<unknown> => {
    const onboardingId = values?.id
    delete values.id
    return apiRequest.withTenantTokenBooking({
        url: ONBOARDING_APIS.UPDATE_APPROVE_REJECT(onboardingId ?? ''),
        method: 'patch',
        data: values
    })
}

export const GET_DOCUMENT_URL = (values: GetDocumentTypes): Promise<unknown> => {
    return apiRequest.withToken({ url: ONBOARDING_APIS.DOCUMENT_URL, method: 'post', data: values })
}

export const PROPERTY_SEARCH_GET = (
    page: number | undefined,
    limit: number | undefined,
    status: string,
    search: string,
    active?: string,
    master_property_id?: string,
    screen?: string,
    propertyManagerId?: string,
    maintainer_id?: string,
    owner_id?: string
): Promise<unknown> => {
    return apiRequest.withTokenProperty({
        url: ONBOARDING_APIS.SEARCH_PROPERTY,
        method: 'get',
        params: {
            site: 'admin',
            page,
            limit,
            ...(status ? { status } : {}),
            ...(search ? { search } : {}),
            ...(active ? { active } : {}),
            ...(master_property_id ? { master_property_id } : {}),
            ...(screen ? { screen } : {}),
            ...(propertyManagerId ? { property_manager_id: propertyManagerId } : {}),
            ...(maintainer_id ? { maintainer_id } : {}),
            ...(owner_id ? { owner_id } : {})
        }
    })
}

export const GET_COLLECTION_DETAILS = (id: string, page?: number, limit?: number): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.COLLECTION_DETAILS(id),
        method: 'get',
        params: { site: 'admin', ...(page ? { page } : {}), ...(limit ? { limit } : {}) }
    })
}
export const PATCH_COLLECTION_DETAILS = (values: CollectionLedgerTypes): Promise<unknown> => {
    const collectionId = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.COLLECTION_UPDATE_PATCH(collectionId ?? ''),
        method: 'patch',
        data: values
    })
}
// RENTAL DOCUMENT ==>

export const UPLOAD_RENTAL_DOCUMENT = (values: any): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.RENTAL_DOCUMENT_UPLOAD, method: 'post', data: values })
}

export const UPDATE_RENTAL_DOCUMENT = (id: string | undefined, values: any): Promise<unknown> => {
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.RENTAL_DOCUMENT_UPDATE(id),
        method: 'patch',
        data: values
    })
}

// TENANT KYC DOCUMENT

export const KYC_POST = (values: KYCDocumentType): Promise<unknown> => {
    return apiRequest.withTenantTokenBooking({
        url: KYC_APIS.KYC_CREATE(),
        method: 'post',
        data: values
    })
}

export const KYC_GET = (search: string): Promise<unknown> => {
    return apiRequest.withTenantTokenBooking({
        url: KYC_APIS.KYC_GET,
        method: 'get',
        params: { ...(search ? { search } : {}) }
    })
}

export const KYC_DELETE = (id: string): Promise<unknown> => {
    console.log('kyc delete function', { url: KYC_APIS.KYC_UPDATE_DELETE(id), method: 'delete' })
    return apiRequest.withTenantTokenBooking({ url: KYC_APIS.KYC_UPDATE_DELETE(id), method: 'delete' })
}

export const KYC_UPDATE = (id: string, values: KYCDocumentType): Promise<unknown> => {
    return apiRequest.withTenantTokenBooking({
        url: KYC_APIS.KYC_UPDATE_DELETE(id),
        method: 'patch',
        data: values
    })
}

// ISSUES ==>

export const GET_ONBOARDING_ISSUES = (
    id: string | undefined,
    status: string | number,
    page: number | undefined,
    limit: number | undefined
): Promise<unknown> => {
    return apiRequest.withToken({
        url: ONBOARDING_APIS.ONBOARDING_ISSUES_GET,
        method: 'get',
        params: { booking_id: id, status, page, limit }
    })
}

export const PATCH_ONBOARDING_ISSUE = (values: OnboardIssueDataType): Promise<unknown> => {
    const id = values?.id
    delete values.id
    return apiRequest.withToken({
        url: ONBOARDING_APIS.ONBOARDING_ISSUE_PATCH(id),
        method: 'patch',
        data: values
    })
}

export const CREATE_ONBOARDING_ISSUE = (values: any): Promise<unknown> => {
    return apiRequest.withToken({ url: ONBOARDING_APIS.ADD_ONBOARDING_ISSUE, method: 'post', data: values })
}

export const GET_SUBTYPES = (type: string | undefined): Promise<unknown> => {
    return apiRequest.withToken({ url: ONBOARDING_APIS.ONBOARDING_SUBTYPES_GET, method: 'get', params: { type } })
}

// MOVE IN DATE ==>

export const GET_MOVE_IN_DATE = (id: string | undefined): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.ONBOARDING_MOVE_IN_DATE_GET_PATCH(id ?? ''),
        method: 'get'
    })
}
// MOVE OUT DATE ==>
export const GET_MOVE_OUT_DATE = (id: string | undefined): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.ONBOARDING_MOVE_OUT_DATE_GET,
        method: 'get',
        params: { booking_id: id }
    })
}
export const PATCH_MOVE_IN_DATE = (values: MoveInDatePatchType): Promise<unknown> => {
    const id = values?.id
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.ONBOARDING_MOVE_IN_DATE_GET_PATCH(id),
        method: 'patch',
        data: values
    })
}
export const GET_TENANT_NO = (number: string): Promise<unknown> => {
    return apiRequest.withTokenTenant({
        url: ONBOARDING_APIS.TENANT_BY_NO,
        method: 'get',
        params: { search: number }
    })
}

export const GET_ALL_ACTIVITIES = (id: string | undefined): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.ONBOARDING_ALL_ACTIVITIES(id ?? ''),
        method: 'get'
    })
}

export const GET_PAYMENT_PENDING = (id: string, pagination: PaginationTypes): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.PENDING_PAYMENTS(id),
        method: 'get',
        params: {
            page: pagination?.current ?? 1,
            limit: pagination?.pageSize ?? 10
        }
    })
}

export const SEND_AGREEMENT_RENTAL = (value: any): Promise<unknown> => {
    const id = value.id ?? ''
    delete value.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.SEND_AGREEMENT(id),
        method: 'post',
        data: value
    })
}
export const RESEND_AGREEMENT_RENTAL = (value: any): Promise<unknown> => {
    const id = value.id ?? ''
    delete value.id
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.RESEND_AGREEMENT(id), method: 'post', data: value })
}
export const TERMINATE_ONBOARDING = (values: any): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: EVICTION_APIS.TERMINATE_TENANT, method: 'post', data: values })
}

//manual agreement
export const SEND_MANUAL_AGREEMENT = (value: any): Promise<unknown> => {
    const id = value.id ?? ''
    delete value.id

    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.MANUAL_AGREEMENT_SEND(id),
        method: 'post',
        data: value
    })
}
export const CHANGE_MOBILE_NUMBER_POST = (values: ChangeMobileNumberType): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.CHANGE_MOBILE_NUMBER,
        method: 'post',
        data: values
    })
}
export const PAYMENT_LINK_ONBOARDING_DUE = (id: string): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.DUE_LINK(id), method: 'get' })
}
export const GET_AGREEMENT_COPY_LINK = (id: string, name: string): Promise<unknown> => {
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.AGREEMENT_COPY_LINK(id),
        method: 'get',
        params: { ...(name ? { name } : {}) }
    })
}

export const ADD_RECORD_DUE = (values: PendingPaymentDataType): Promise<unknown> => {
    const id = values?.id || ''
    delete values.id
    return apiRequest.withTokenBooking({
        url: ONBOARDING_APIS.RECORD_DUE(id),
        method: 'post',
        data: values
    })
}

export const DELETE_RENTAL_DOCUMENT = (id: string): Promise<unknown> => {
    return apiRequest.withTokenBooking({ url: ONBOARDING_APIS.RENTAL_DOCUMENT_DELETE(id), method: 'delete' })
}
export const GET_ONBOARDING_INVENTORY = async (
    search: string,
    page: number | undefined,
    limit: number | undefined,
    property_id?: string,
    sortingOptions?: SortingKeys,
    filterOptions?: any
): Promise<unknown> => {
    return apiRequest.withTokenProperty({
        url: ONBOARDING_APIS.ONBOARDING_INVENTORY_GET,
        method: 'get',
        params: {
            page,
            limit,
            ...(search ? { search } : {}),
            ...(property_id ? { property_id: property_id } : {}),
            ...(sortingOptions?.sort ? { sort: sortingOptions?.sort } : {}),
            ...filterOptions
        }
    })
}

// INSPECTION APIS ==>

export const GET_LIST_INSPECTIONS = (params?: InspectionQueryParams): Promise<unknown> =>
    apiRequest.withTokenInspection({
        url: ONBOARDING_APIS.INSPECTION,
        method: 'get',
        params: Object.fromEntries(Object.entries(params ?? {}).filter(([, value]) => value))
    })

export const GET_INSPECTION_BY_ID = (id: string): Promise<unknown> => {
    return apiRequest.withTokenInspection({
        url: ONBOARDING_APIS.INSPECTION_BY_ID(id),
        method: 'get'
    })
}

export const CREATE_INSPECTION = (values: CreateInspectionPayload): Promise<unknown> => {
    return apiRequest.withTokenInspection({
        url: ONBOARDING_APIS.INSPECTION,
        method: 'post',
        data: values
    })
}

export const PATCH_INSPECTION = (id: string, values: UpdateInspectionPayload): Promise<unknown> => {
    return apiRequest.withTokenInspection({
        url: ONBOARDING_APIS.INSPECTION_BY_ID(id),
        method: 'patch',
        data: values
    })
}

export const DELETE_INSPECTION = (id: string): Promise<unknown> => {
    return apiRequest.withTokenInspection({
        url: ONBOARDING_APIS.INSPECTION_BY_ID(id),
        method: 'delete'
    })
}
